import { createBrowserHistory } from 'history';
import { action, computed, observable } from 'mobx';
import { Location } from 'history';

export const history = createBrowserHistory();

class NavigationStore {
    @observable private _currentLocation: Location;

    @action
    init() {
        this._currentLocation = Object.create(history.location);
        history.listen((location: Location) => {
            this._currentLocation = location;
        });
    }

    //NAVIGATION
    @action
    redirect<T>(url: string, isCtrlKey: boolean = false, state?: T) {
        if (isCtrlKey) {
            const target = '_blank';
            const win = window.open(url, target);
            win && win.focus();
            return;
        }

        if (state) {
            history.push({ pathname: url, state: state });
        } else {
            history.push(url);
        }
    }

    replace<T>(url: string, state?: T) {
        if (state) {
            history.replace({ pathname: url, state: state });
        } else {
            history.replace(url);
        }
    }

    @computed
    get currentLocation() {
        return this._currentLocation;
    }
}

export const navigationStore = new NavigationStore();